import { kDropboxAuthorizePath } from '@/constants/constants-api-paths'
import getExternalStorageAuthorizeUrl from '@/settings/fetch/get-external-storage-authorize-url'
import { ExternalStorageAuthorizeResponse } from '@/settings/schemas/external-storage-schema'

export enum DropboxAccountRole {
  PERSONAL = 'personal',
  WORK = 'work',
}

export default async function getDropboxAuthorizeUrl(accountRole?: DropboxAccountRole): Promise<ExternalStorageAuthorizeResponse> {
  const query = accountRole ? `?${new URLSearchParams({ account_role: accountRole })}` : ''
  return getExternalStorageAuthorizeUrl(`${kDropboxAuthorizePath}${query}`)
}
